import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  MALL_PAGE_PATH,
  MALL_PAGE_ADD_PATH,
  MALL_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const MallDetailsPage = Loadable(React.lazy(() => import("./View")));
const MallDetailsPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const MallRoute: IRouteItem = {
  path: MALL_PAGE_PATH,
  element: React.createElement(MallDetailsPage),
  name: "Mall",
  children: [
    {
      name: "Add / Update",
      path: MALL_PAGE_ADD_PATH,
      element: React.createElement(MallDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: MALL_PAGE_UPDATE_PATH,
      element: React.createElement(MallDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
